<template>
  <div class="product-design-statistics">
    <portal to="layout-nav-title">服装制单数据统计</portal>

    <!-- Tab切换 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane
        v-if="abilityService.can('product_designs.read_role_statistics')"
        label="角色"
        name="role"
      >
        <!-- 角色过滤表单 -->
        <div class="filter-form">
          <el-form :inline="true" :model="filterForms.role" class="form-inline">
            <el-form-item label="设计师">
              <el-select
                v-model="filterForms.role.designer_id_eq"
                placeholder="请选择设计师"
                clearable
                filterable
                remote
                :remote-method="searchDesigners"
                :loading="loading.options"
              >
                <el-option
                  v-for="user in staticData.designers"
                  :key="user.id"
                  :label="user.label"
                  :value="user.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="项目">
              <el-select
                v-model="filterForms.role.project_id_eq"
                placeholder="请选择项目"
                clearable
                filterable
                remote
                :remote-method="searchProjects"
                :loading="loading.options"
              >
                <el-option
                  v-for="item in staticData.projects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="版房类型">
              <el-select
                v-model="filterForms.role.pattern_factory_eq"
                placeholder="请选择版房类型"
                clearable
                :loading="loading.options"
              >
                <el-option
                  v-for="type in staticData.patternFactorys"
                  :key="type.value"
                  :label="type.label"
                  :value="type.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="供应商">
              <el-select
                v-model="filterForms.role.company_id_eq"
                placeholder="请选择供应商"
                clearable
                filterable
                remote
                :remote-method="searchSuppliers"
                :loading="loading.options"
              >
                <el-option
                  v-for="supplier in staticData.companies"
                  :key="supplier.id"
                  :label="supplier.name"
                  :value="supplier.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="漏斗图状态">
              <el-select
                v-model="filterForms.role.virtual_state_in"
                placeholder="请选择漏斗图状态"
                clearable
                multiple
                collapse-tags
                :loading="loading.options"
              >
                <el-option
                  v-for="item in staticData.roleFunnelStates"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <el-date-picker
                v-model="filterForms.role.date_range"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleFilter">查询</el-button>
              <el-button @click="resetFilter('role')">重置</el-button>
              <el-button type="success" @click="exportRoleData">导出</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 角色漏斗图 -->
        <div class="funnel-chart">
          <ECharts ref="roleFunnelChart" :options="roleFunnelChartOption" style="width:100%; display:flex; justify-content:center;" @click="handleFunnelClick"/>
        </div>

        <!-- 角色条形明细图 -->
        <div class="bar-chart">
          <ECharts ref="roleBarChart" :options="roleBarChartOption" style="width:100%;height:600px;" @click="handleRoleBarClick"/>
        </div>
      </el-tab-pane>

      <el-tab-pane
        v-if="abilityService.can('product_designs.read_factory_statistics')"
        label="版房"
        name="factory"
      >
        <!-- 版房过滤表单 -->
        <div class="filter-form">
          <el-form :inline="true" :model="filterForms.factory" class="form-inline">
            <el-form-item
              v-if="!['supplier_boss'].includes($root.user.current_role.role.kind)"
              label="版房类型"
            >
              <el-select
                v-model="filterForms.factory.pattern_factory_eq"
                placeholder="请选择版房类型"
                clearable
                :loading="loading.options"
              >
                <el-option
                  v-for="type in staticData.patternFactorys"
                  :key="type.value"
                  :label="type.label"
                  :value="type.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="!['supplier_boss'].includes($root.user.current_role.role.kind)"
              label="供应商"
            >
              <el-select
                v-model="filterForms.factory.company_id_eq"
                placeholder="请选择供应商"
                clearable
                :loading="loading.options"
              >
                <el-option
                  v-for="supplier in staticData.companies"
                  :key="supplier.id"
                  :label="supplier.name"
                  :value="supplier.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="漏斗图状态">
              <el-select
                v-model="filterForms.factory.virtual_state_in"
                placeholder="请选择漏斗图状态"
                clearable
                multiple
                collapse-tags
                :loading="loading.options"
              >
                <el-option
                  v-for="item in staticData.factoryFunnelStates"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <el-date-picker
                v-model="filterForms.factory.date_range"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleFilter">查询</el-button>
              <el-button @click="resetFilter('factory')">重置</el-button>
              <el-button type="success" @click="exportFactoryData">导出</el-button>
              <el-button type="success" @click="generateFactoryReport">生成报表</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 版房漏斗图 -->
        <div class="funnel-chart">
          <ECharts ref="factoryFunnelChart" :options="factoryFunnelChartOption" style="width:100%; display:flex; justify-content:center;" @click="handleFunnelClick"/>
        </div>

        <!-- 版房条形明细图 -->
        <div class="bar-chart">
          <ECharts ref="factoryBarChart" :options="factoryBarChartOption" style="width:100%;height:600px;" @click="handleFactoryBarClick"/>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 详情弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :before-close="handleDialogClose"
      width="90%"
    >
      <bean-table
        width="100%"
        :value="tableData"
        :columns="tableColumns"
        :height="null"
        :actions="[]"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator';
import { PRODUCT_DESIGN_PATTERN_FACTORIES } from '@/admin_entities/product_design_detail';
import ECharts from 'vue-echarts';
import { itemLabel } from '@/custom_columns_extend';
import { columnsExtend } from '@/admin_grapes/product_designs.js';
import { abilityService } from 'beans-admin-plugin';

@Component({
  components: {
    ECharts
  }
})
export default class ProductDesignStatistics extends Vue {
  // Services
  abilityService = abilityService;

  // 加载状态
  loading = {
    options: false,
    chart: false
  };

  // 弹窗相关数据
  dialogVisible = false;
  dialogTitle = '数据明细';
  tableLoading = false;
  tableData = [];
  tableColumns = [];

  // Tab相关
  activeTab = this.abilityService.can('product_designs.read_role_statistics') ? 'role' : 'factory';

  // 静态数据
  staticData = {
    // 下拉选项数据
    companies: [],
    projects: [],
    designers: [],
    patternFactorys: PRODUCT_DESIGN_PATTERN_FACTORIES.map(type => ({
      label: this.$t(`productDesign.patternFactories.${type}`),
      value: type
    })),
    roleFunnelStates: [
      { label: '已下版', value: 'audited' },
      { label: '已出版', value: 'completed' },
      { label: '未出版', value: 'wait_publication' },
      { label: '未核价', value: 'not_quantity_audited' },
      { label: '有拒单', value: 'ever_rejected' },
      { label: '已下单', value: 'ever_order' },
    ],
    factoryFunnelStates: [
      { label: '已下版', value: 'audited' },
      { label: '车版完成', value: 'on_or_after_sewed_completed' },
      { label: '未出版', value: 'wait_publication' },
      { label: '未核价', value: 'not_quantity_audited' },
      { label: '样版签收', value: 'on_or_after_signed_sample' },
      { label: '逾期', value: 'overdue' },
      { label: '样板总成本', value: 'cost_price_present' },
      { label: '报价准时', value: 'audit_quantity_on_time' },
    ]
  };

  // 过滤表单
  filterForms = {
    role: {
      project_id_eq: null,
      designer_id_eq: null,
      pattern_factory_eq: null,
      company_id_eq: null,
      virtual_state_in: [],
      date_range: [
        new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        new Date().toISOString().split('T')[0]
      ],
    },
    factory: {
      pattern_factory_eq: null,
      company_id_eq: null,
      virtual_state_in: [],
      date_range: [
        new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        new Date().toISOString().split('T')[0]
      ],
    }
  };

  // 数据
  chartData = {
    roleFunnelData: [],
    factoryFunnelData: [],
    roleBarData: [],
    factoryBarData: []
  };

  // 日期选择器配置
  get datePickerOptions() {
    return {
      shortcuts: [
        {
          text: '今天',
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '近7天',
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '近30天',
          onClick: (picker) => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        },
      ]
    };
  }

  searchProjects(query) {
    this.$request.get('projects/read_options', { per_page: 100, keyword: query }).then(res => {
      this.staticData.projects = res.data;
    });
  }

  searchSuppliers(query) {
    this.$request.get('companies/read_options', { per_page: 100, keyword: query }).then(res => {
      this.staticData.companies = res.data;
    });
  }

  searchDesigners(query) {
    this.$request.get('users/read_options', {
      per_page: 100,
      keyword: query,
      role_in: ['designer', 'salesman', 'sales_director']
    }).then(res => {
      this.staticData.designers = res.data.map(user => ({
        ...user,
        label: itemLabel(user)
      }));
    });
  }

  get roleFunnelChartOption() {
    return this.getFunnelChartOption(this.chartData.roleFunnelData);
  }

  get factoryFunnelChartOption() {
    return this.getFunnelChartOption(this.chartData.factoryFunnelData);
  }

  get roleBarChartOption() {
    return this.getBarChartOption(this.chartData.roleBarData);
  }

  get factoryBarChartOption() {
    return this.getBarChartOption(this.chartData.factoryBarData);
  }

  getBarChartOption(data) {
    // 对数据按照value值进行排序
    const sortedData = [...data].sort((a, b) => a.value - b.value);

    // 提取名称和值，并构建带有id的数据
    const names = sortedData.map(item => item.name);
    const values = sortedData.map(item => ({
      value: item.value,
      user_id: item.user_id, // 添加id属性
      // 可以添加其他需要的属性
      itemStyle: {
        color: '#5470c6'
      }
    }));

    return {
      title: {
        text: ''
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: names,
        axisLabel: {
          show: true
        }
      },
      series: [
        {
          name: '数量',
          type: 'bar',
          data: values,
          label: {
            show: true,
            position: 'right',
            formatter: '{c}'
          }
        }
      ]
    };
  }

  // 提取共用的漏斗图配置方法
  getFunnelChartOption(data) {
    return {
      title: {
        text: ''
      },
      series: [
        {
          name: '制单',
          type: 'funnel',
          top: 60,
          bottom: 60,
          width: '80%',
          min: 0,
          max: 100,
          minSize: '0%',
          maxSize: '100%',
          sort: 'descending',
          gap: 2,
          label: {
            show: true,
            formatter: (params) => {
              return `${params.name}: ${params.data.count} 个 (转化率: ${params.value}%)`;
            }
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          data: data
        }
      ],
      tooltip: {
        trigger: 'item'
      }
    };
  }

  // 添加漏斗图点击事件处理方法
  handleFunnelClick(params) {
    if (this.activeTab === 'role') {
      if (this.filterForms.role.virtual_state_in.includes(params.data.virtual_state)) {
        this.filterForms.role.virtual_state_in = this.filterForms.role.virtual_state_in.filter(state => state !== params.data.virtual_state);
      } else {
        this.filterForms.role.virtual_state_in.push(params.data.virtual_state);
      }
    } else {
      if (this.filterForms.factory.virtual_state_in.includes(params.data.virtual_state)) {
        this.filterForms.factory.virtual_state_in = this.filterForms.factory.virtual_state_in.filter(state => state !== params.data.virtual_state);
      } else {
        this.filterForms.factory.virtual_state_in.push(params.data.virtual_state);
      }
    }
    this.handleFilter();
  }

  // 生命周期钩子
  mounted() {
    // 初始化数据
    this.fetchOptionsData();
    // 初始加载图表数据
    this.fetchInitialChartData();
  }

  // 处理过滤查询
  async handleFilter() {
    try {
      this.loading.chart = true;

      if (this.activeTab === 'role') {
        this.fetchRoleStatistics()
      } else {
        this.fetchFactoryStatistics()
      }
    } finally {
      this.loading.chart = false;
    }
  }

  // 重置过滤条件
  resetFilter(type) {
    const defaultForm = {
      pattern_factory_eq: null,
      company_id_eq: null,
      virtual_state_in: [],
      date_range: [
        new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        new Date().toISOString().split('T')[0]
      ],
    };

    // 只重置project字段（如果存在）
    this.filterForms[type] = {
      ...defaultForm,
      project_id_eq: type === 'role' ? null : undefined,
      designer_id_eq: type === 'role' ? null : undefined
    };

    this.handleFilter();
  }

  async fetchRoleStatistics() {
    const roleResponse = await this.$request.get('product_designs/role_statistics', { params: this.filterForms.role });
    this.chartData.roleFunnelData = roleResponse.funnel_data;
    this.chartData.roleBarData = roleResponse.bar_data;
  }

  async fetchFactoryStatistics() {
    const factoryResponse = await this.$request.get('product_designs/factory_statistics', { params: this.filterForms.factory });
    this.chartData.factoryFunnelData = factoryResponse.funnel_data;
    this.chartData.factoryBarData = factoryResponse.bar_data;
  }

  // 获取初始图表数据
  async fetchInitialChartData() {
    try {
      this.loading.chart = true;

      if (this.abilityService.can('product_designs.read_role_statistics')) {
        await this.fetchRoleStatistics();
      }
      if (this.abilityService.can('product_designs.read_factory_statistics')) {
        await this.fetchFactoryStatistics();
      }
    } finally {
      this.loading.chart = false;
    }
  }

  // 处理条形图点击
  handleRoleBarClick(params) {
    this.dialogTitle = '数据明细';
    this.dialogVisible = true;

    this.fetchRoleStatisticsDetailData(params.data.user_id);
  }

  handleFactoryBarClick(params) {
    if (params.data) {
      this.dialogVisible = true;
      this.tableLoading = true;
    }

    this.fetchFactoryStatisticsDetailData(params.data.user_id);
  }

  async fetchRoleStatisticsDetailData(id) {
    try {
      this.tableLoading = true;
      this.tableData = await this.$request.get('product_designs/role_statistics_detail', {
        params: {
          ...this.filterForms.role,
          designer_id_eq: id,
        }
      });
      this.tableColumns = columnsExtend([
        {
          prop: 'date',
          label: '时间',
          width: 100
        },
        { prop: 'role', label: '角色' },
        { prop: 'profile_name', label: '姓名', minWidth: 100 },
        { key: 'design_type' },
        { key: 'pattern_factory' },
        { prop: 'company_name', label: '供应商' },
        { key: 'number' },
        { prop: 'over_due_state', label: '交版状态' },
        { prop: 'in_advance_days', label: '提前天数' },
        { prop: 'overdue_days', label: '逾期天数' },
        { prop: 'total_reject_count', label: '被拒绝次数' },
        { key: 'reject_reason' },
        {
          prop: 'transaction_flag',
          label: '是否成交',
          renderCell: 'bool'
        },
      ].filter(Boolean));
    } finally {
      this.tableLoading = false;
    }
  }

  async fetchFactoryStatisticsDetailData(id) {
    try {
      this.tableLoading = true;
      this.tableData = await this.$request.get('product_designs/factory_statistics_detail', {
        params: {
          ...this.filterForms.factory,
          designer_id_eq: id,
        }
      });
      this.tableColumns = columnsExtend([
        {
          prop: 'date',
          label: '时间',
          width: 100
        },
        { key: 'pattern_factory' },
        { prop: 'company_name', label: '供应商' },
        { key: 'number' },
        { prop: 'over_due_state', label: '交版状态' },
        { prop: 'in_advance_days', label: '提前天数' },
        { prop: 'overdue_days', label: '逾期天数' },
        { prop: 'second_overdue_days', label: '二次逾期天数' },
        {
          prop: 'audit_quantity_on_time',
          label: '报价准时',
          renderCell: (h, { props: { value } }) => {
            if (value === true) return h('el-tag', { props: { type: 'success' } }, '是');
            if (value === false) return h('el-tag', { props: { type: 'danger' } }, '否');
            return '';
          }
        },
      ].filter(Boolean));
    } finally {
      this.tableLoading = false;
    }
  }

  // 处理弹窗关闭
  handleDialogClose(done) {
    this.tableData = [];
    this.tableColumns = [];
    done();
  }

  // 获取选项数据
  async fetchOptionsData() {
    try {
      this.loading.options = true;

      // 获取项目数据
      if (this.abilityService.can('product_designs.read_role_statistics')) {
        const projectsResponse = await this.$request.get('projects/read_options', { per_page: 100 });
        this.staticData.projects = projectsResponse.data;

        // 获取设计师数据
        const designersResponse = await this.$request.get('users/read_options', {
          per_page: 100,
          is_block_eq: false,
          role_in: ['designer', 'salesman', 'sales_director']
        });
        this.staticData.designers = designersResponse.data.map(user => ({
          ...user,
          label: itemLabel(user)
        }));
      }

      if (this.abilityService.can('product_designs.read_factory_statistics')) {
        // 获取供应商数据
        const suppliersResponse = await this.$request.get('companies/read_options', { per_page: 100 });
        this.staticData.companies = suppliersResponse.data;
      }
    } finally {
      this.loading.options = false;
    }
  }

  // 添加watch监听activeTab变化
  @Watch('activeTab')
  onActiveTabChange(newVal, oldVal) {
    if (newVal !== oldVal) {
      this.handleFilter();
    }
  }

  // 处理Tab切换
  handleTabClick() {
    // 给Vue一个更新DOM的机会
    this.$nextTick(() => {
      // 获取所有图表实例并强制重新渲染
      const chartRefs = ['roleFunnelChart', 'roleBarChart', 'factoryFunnelChart', 'factoryBarChart'];
      chartRefs.forEach(ref => {
        const chart = this.$refs[ref];
        if (chart) {
          chart.resize();
        }
      });
    });
  }

  // 导出角色数据
  async exportRoleData() {
    await this.$request.get('product_designs/export_role_statistics_detail', { params: this.filterForms.role });
    this.$message.success('文件正在导出，导出成功后将会发送到邮箱');
  }

  // 导出版房数据
  async exportFactoryData() {
    await this.$request.get('product_designs/export_factory_statistics_detail', { params: this.filterForms.factory });
    this.$message.success('文件正在导出，导出成功后将会发送到邮箱');
  }

  // 生成版房报表
  async generateFactoryReport() {
    const options = { timeout: 30 * 60 * 1000, responseType: 'blob', return_res: true }
    const result = await this.$autoLoading(this.$request.get('/product_designs/generate_factory_report', { params: this.filterForms.factory }, options))
    const blob = new Blob([result.data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = '服装制单报表.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export const route = [
  {
    path: '/product_design_statistics',
    name: 'product_design_statistics',
    component: ProductDesignStatistics,
    meta: {
      can: ['product_designs.read_statistics']
    }
  }
];
</script>

<style lang="scss" scoped>
.product-design-statistics {
  padding: 20px;

  .filter-form,
  .bar-chart {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  }

  .dialog-footer {
    text-align: right;
    margin-top: 20px;
  }
}
</style>
